import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const GoldenMomentsRoutes = [
  {
    path: '',
    name: 'Home',
    component: () => import('@/views/Home/Home'),
  },
  {
    path: '/collectibles/:collectibleId/:tokenId',
    name: 'Collectible',
    component: () => import('@/views/Collectibles/Collectible'),
  },
  {
    path: '/shop',
    name: 'Shop',
    component: () => import('@/views/Payment/Shop'),
  },
  {
    path: '/marketplace',
    name: 'Marketplace',
    component: () => import('@/views/Marketplace/Marketplace'),
  },
  {
    path: '/drops',
    name: 'Drops',
    component: () => import('@/views/Drops/Drops'),
  },
  {
    path: '/drops/:collectibleId',
    name: 'Drop',
    component: () => import('@/views/Drops/Drop/Drop'),
  },
  {
    path: '/drops/:collectibleId/premium',
    name: 'Drop',
    component: () => import('@/views/Drops/Drop/Drop'),
  },
  {
    path: '/challenges',
    name: 'Challenges',
    component: () => import('@/views/Challenges/Challenges'),
  },
  {
    path: '/challenges/:challengeId',
    name: 'Challenge',
    component: () => import('@/views/Challenges/Challenge/Challenge'),
  },
  {
    path: '/collection',
    name: 'Collection',
    component: () => import('@/views/Collection/Collection'),
  },
  {
    name: 'Authentication',
    path: '/auth',
    component: () => import('@/views/auth/Authentication'),
  },
  {
    name: 'Profile',
    path: '/profile',
    component: () => import('@/views/Profile/Profile'),
  },
];

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/Index'),
      children: [...GoldenMomentsRoutes],
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
